import { render, staticRenderFns } from "./AdvShopStat.vue?vue&type=template&id=3ddc68d4&scoped=true&"
import script from "./AdvShopStat.vue?vue&type=script&lang=js&"
export * from "./AdvShopStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc68d4",
  null
  
)

export default component.exports